module.exports = __webpack_public_path__ + "static/media/disabled-btn-icon.ba140c02.svg";